var map = {
	"./a5.png": "EK0F",
	"./a5en.png": "Cyp/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D3ZW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet ^\.\/a5.*\.png$
// module id = D3ZW
// module chunks = 0